<script lang="ts">
	// routes/[lang]/+page.svelte
	// THIS IS THE MAIN STORY PAGE
	import Navbar from '$components/Navbar/Navbar.svelte';
	import { initializeStores } from '@skeletonlabs/skeleton';
	import { Drawer, getDrawerStore } from '@skeletonlabs/skeleton';
	import MenuDrawer from '$components/Navbar/menu/MenuDrawer.svelte';
	import Article from '$components/Article/Article.svelte';
	import Byline from '$components/Byline/Byline.svelte';
	import Hero from '$components/Hero/Hero.svelte';
	import BodyText from '$components/BodyText/BodyText.svelte';
	import Footer from '$components/Footer/Footer.svelte';
	import SingleImage from '$components/SingleImage/SingleImage.svelte';
	import AudioText from '$components/AudioText/AudioText.svelte';
	import Intro from '$components/Intro/Intro.svelte';
	import { error } from '@sveltejs/kit';

	// TYPES
	import type { PageData } from './$types';
	import CreditBox from '$components/CreditBox/CreditBox.svelte';

	// PROPS
	export let data: PageData;

	// VARIABLES
	initializeStores();
	const drawerStore = getDrawerStore();

	if (!data.current) {
		throw error(500, {
			message: 'current property is not defined in PageData object',
			file: 'src/routes/[version]/+page.svelte',
		});
	}

	const current = data.current;
	const content = data.textData;
	const navbarText = data.textData.ui.navbar;

	if (!data.textData.blocks) {
		throw error(500, {
			message: 'No `blocks` found in PageData object. Check ArchieML file.',
			file: 'src/routes/[version]/+page.svelte',
		});
	}
</script>

<Drawer>
	{#if drawerStore}
		<MenuDrawer text="{navbarText}" />
	{:else}
		<!-- (fallback contents) -->
		<p>Fallback!</p>
	{/if}
</Drawer>
<Navbar {current} />
<Article>
	<Hero title="{content.hero.title}" subtitle="{content.hero.subtitle}" />

	<!-- 🔁 Looping through your Google doc blocks... -->
	{#each content.blocks as block}
		{#if block.Type == 'Byline'}
			<Byline authorString="{block.authorString}" dateline="{block.dateline}" />
		{/if}
		{#if block.Type == 'Intro'}
			<Intro text="{block.data}" />
		{/if}
		{#if block.Type === 'AudioText'}
			<AudioText id="{block.id}" data="{block.data}" />
		{/if}
		{#if block.Type === 'BodyText'}
			<BodyText text="{block.data}" variant="{block.variant}" />
		{/if}
		<!-- {#if block.Type === 'Video'}
			<VideoPlayer
				desc="{block.desc}"
				credit="{block.credit}"
				fileUrl="{block.fileUrl}"
				subs="{block.subs}"
			/>
		{/if} -->
		<!-- {#if block.Type === 'Audio'}
			<AudioPlayer
				fileName="{block.fileName}"
				description="{block.description}"
				captions="{block.captions}"
			/>
		{/if} -->
		{#if block.Type === 'SingleImage'}
			<SingleImage
				url="{block.url}"
				thumbhash="{block.thumbhash}"
				caption="{block.caption}"
				credit="{block.credit}"
			/>
		{/if}
		<!-- {#if block.Type === 'ScrollyMap'}
			<ScrollyMap
				legend="{block.legend}"
				mapData="{data.mapData}"
				steps="{block.steps}"
				lang="{current.lang}"
			/>
		{/if}
		{#if block.Type === 'ExpandableBox'}
			<ExpandableBox data="{block.data}" />
		{/if} -->
		{#if block.Type == 'CreditBox'}
			<CreditBox note="{block.note}" credits="{block.credits}" />
		{/if}
	{/each}
</Article>
<Footer data="{content.ui.footer}" />
